<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          아이템
        </div>
        <div>
          <item-list-component :item-type="`item`"></item-list-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItemListComponent from "@/components/item/ItemListComponent";

export default {
  name: "Item",
  mixins: [],
  components: {
    ItemListComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>